import FacilitatorMessaging from '@/src/components/game/FacilitatorMessaging/FacilitatorMessaging';
import React from 'react';

export const JamEventFacilitatorMessagingPage: React.FC = () => {
  return <FacilitatorMessaging />;
};
